import { Activity, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import ProfileMenu from "@/components/ProfileMenu";
import NotificationBell from "@/components/NotificationBell";

const ROLE_LABEL = {
  user: "User",
  manager: "Manager",
  super_manager: "Super Manager",
  super_admin: "Super Admin",
};

export default function Navbar({ subtitle }) {
  return (
    <header className="sticky top-0 z-30 bg-card/80 backdrop-blur-md border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="h-9 w-9 rounded-xl bg-primary flex items-center justify-center">
            <Activity className="h-5 w-5 text-white" />
          </div>
          <div className="leading-tight">
            <span className="font-heading font-bold text-lg block">ABS Pulse</span>
            {subtitle && (
              <span className="text-xs text-muted-foreground font-mono">{subtitle}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1.5">
          <Link to="/guide" className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-primary transition-colors rounded-lg px-2.5 py-1.5" data-testid="nav-guide-link" title="App guide">
            <BookOpen className="h-4 w-4" /> <span className="hidden sm:inline">Guide</span>
          </Link>
          <NotificationBell />
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
}
